import { render, staticRenderFns } from "./MineCourse.vue?vue&type=template&id=fdb0a202"
import script from "./MineCourse.vue?vue&type=script&lang=js"
export * from "./MineCourse.vue?vue&type=script&lang=js"
import style0 from "./MineCourse.vue?vue&type=style&index=0&id=fdb0a202&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports